import { z } from "zod";
export const DTOScimResourceType = z.object({
    schemas: z
        .array(z.string())
        .default(["urn:ietf:params:scim:schemas:core:2.0:ResourceType"]),
    id: z.string().optional(),
    name: z.string(),
    description: z.string(),
    endpoint: z.string(),
    schema: z.string(),
    schemaExtensions: z
        .array(z.object({
        schema: z.string(),
        required: z.boolean(),
    }))
        .optional(),
    meta: z.object({
        location: z.string(),
        resourceType: z.string(),
    }),
});
export const DTOScimResourceTypeList = z.array(DTOScimResourceType);
